import React, { ReactNode } from 'react';
import { Drawer, IconButton, Typography, Stack, Divider } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faXmark,
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';

import styles from './SidePanel.module.scss';

export type SidePanelProps = {
  children?: ReactNode | ReactNode[];
  items: any[];
  isPanelOpen: boolean;
  setIsPanelOpen: (isOpen: boolean) => void;
  selectedItem: any | null;
  setSelectedItem: (item: any | null) => void;
};

export const SidePanel = (props: SidePanelProps) => {
  const {
    children,
    isPanelOpen,
    setIsPanelOpen,
    items,
    selectedItem,
    setSelectedItem,
  } = props;

  const selectedItemIndex = selectedItem
    ? items.findIndex(item => item.id === selectedItem.id)
    : -1;

  const onPrev = () => {
    if (selectedItemIndex > 0) {
      const newIndex = selectedItemIndex - 1;
      setSelectedItem(items[newIndex]);
    }
  };

  const onNext = () => {
    if (selectedItemIndex >= 0 && selectedItemIndex < items.length - 1) {
      setSelectedItem(items[selectedItemIndex + 1]);
    }
  };

  return (
    <Drawer
      anchor="right"
      open={isPanelOpen}
      onClose={() => setIsPanelOpen(false)}
      slotProps={{ paper: { className: styles.drawer } }}
    >
      <div className={styles.navigation}>
        <Stack direction="row" alignItems="center">
          <IconButton
            size="small"
            onClick={onPrev}
            disabled={selectedItemIndex <= 0}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </IconButton>
          <IconButton
            size="small"
            onClick={onNext}
            disabled={
              selectedItemIndex === -1 || selectedItemIndex >= items.length - 1
            }
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </IconButton>
          {'\u00A0'}
          <Typography>
            {selectedItemIndex + 1} / {items.length}
          </Typography>
        </Stack>
        <IconButton onClick={() => setIsPanelOpen(false)}>
          <FontAwesomeIcon icon={faXmark} />
        </IconButton>
      </div>
      <Divider />

      <div className={styles.body}>{children}</div>
    </Drawer>
  );
};

export default SidePanel;
